import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthUserService } from '../init/auth-user.service';

@Injectable({ providedIn: 'root' })
export class AuthRedirectService {
  private readonly portariaBaseUrl = environment.production
    ? 'https://portaria.cipa.smosc.com.br'
    : 'http://localhost:10050';

  private readonly authBaseUrl = environment.production
    ? 'https://portaria.smosc.com.br'
    : 'http://portaria.localhost.smosc.com.br';

  private readonly serviceName = 'smoacademy';
  private readonly authStorageKeys = [
    'tokenValor',
    'tokenAtualizacao',
    'expiraEm',
    'tempoAuxiliar',
    'isAuthenticated',
    'isAuthenticationComplete',
    'token',
    'refreshToken',
    'expiresAt',
    'auxTime',
  ];

  constructor(
    private readonly authUserService: AuthUserService,
  ) {}

  redirectToAuthentication(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const currentUrl = this.getCurrentUrlWithoutAuthParams();
    const redirectUrl = `${this.authBaseUrl}/?servico=${encodeURIComponent(this.serviceName)}&recurso=${encodeURIComponent(currentUrl)}`;
    window.location.href = redirectUrl;
  }

  logout(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const redirectUrl = this.buildPortariaRedirectUrlFromStoredContext();

    this.clearAuthStorage(localStorage);
    this.clearAuthStorage(sessionStorage);
    window.location.assign(redirectUrl);
  }

  private buildPortariaRedirectUrlFromStoredContext(): string {
    const currentUser = this.authUserService.getCurrentUser();
    const companySuffix = currentUser.companySuffix;
    const electionGuid = currentUser.electionGuid;
    const path = companySuffix && electionGuid
      ? `/${encodeURIComponent(companySuffix)}/${encodeURIComponent(electionGuid)}`
      : '';

    return `${this.portariaBaseUrl}${path}`;
  }

  private getCurrentUrlWithoutAuthParams(): string {
    const url = new URL(window.location.href);
    url.searchParams.delete('cd');
    url.searchParams.delete('t');
    url.searchParams.delete('s');
    return url.toString();
  }

  private clearAuthStorage(storage: Storage): void {
    for (const key of this.authStorageKeys) {
      storage.removeItem(key);
    }
  }
}